module.exports = __webpack_public_path__ + "static/media/sangram.26ff3d1a.png";